export function getSoleElementIfExists<T>(array: T[]): (T | null) {
  switch(array.length) {
  case 0:
    return null;
  case 1:
    return array[0];
  default:
    throw Error('The specified array has multiple elements.');
  }
}

export const hasIntersection = (ary1, ary2) => ary1.filter(e => ary2.includes(e)).length > 0;
